import * as Redux from 'redux'
import { Grid } from '@mui/material'
import { ICommonQuery } from '@Models/common.model'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import ClientFirearmActions from '@ClientActions/firearm.action'
import BoxTitle from '@Components/Form/BoxTitle/BoxTitle'
import PageHeader from '@Components/Pages/PageHeader/PageHeader'
import Accessories from './Accessories'
import Firearms from './Firearms'

function DisposeOfFirearm(props: any) {
    const {
        firearms,
        getFirearms,
        getAccessories,
        accessories,
        parts,
        getParts,
    } = props
    const initialVault = () => {
        const params = {
            status: 'BOUGHT',
            isDetail: true,
        }
        getFirearms(params)
        getAccessories(params)
        getParts(params)
    }

    useEffect(() => {
        initialVault()
    }, [])
    return (
        <div className="dispose-of-firearam">
            <div className="my-account">
                <PageHeader title="Dispose of Firearm" />
                <BoxTitle title="Firearms" />
                <Grid container spacing={3}>
                    {firearms?.length > 0 && (
                        <Firearms
                            data={firearms}
                            submitChanged={initialVault}
                        />
                    )}
                    {!firearms?.length && <p className="no-data">No data</p>}
                </Grid>
                <BoxTitle title="Accessories" className="mt-4" />
                <Grid container spacing={3}>
                    {accessories?.length > 0 && (
                        <Firearms
                            data={accessories}
                            submitChanged={initialVault}
                        />
                    )}
                    {!accessories?.length && <p className="no-data">No data</p>}
                </Grid>

                <BoxTitle title="Parts" className="mt-4" />
                <Grid container spacing={3}>
                    {parts?.length > 0 && (
                        <Firearms data={parts} submitChanged={initialVault} />
                    )}
                    {!parts?.length && <p className="no-data">No data</p>}
                </Grid>
            </div>
        </div>
    )
}

const mapStateToProps = (store: any) => {
    return {
        firearms: store?.client?.firearms?.firearmData,
        accessories: store?.client?.accessories?.accessoriesData,
        parts: store?.client?.parts?.partData,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    return {
        getFirearms: (params: ICommonQuery) =>
            dispatch(ClientFirearmActions.getItems('FIREARM', params) as any),
        getAccessories: (params: ICommonQuery) =>
            dispatch(ClientFirearmActions.getItems('ACCESSORY', params) as any),
        getParts: (params: ICommonQuery) =>
            dispatch(ClientFirearmActions.getItems('PART', params) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DisposeOfFirearm)
